<template>
  <div class="content-area">
    <div class="w-100 px-5 py-4">
      <div slot="title">
        <h1>{{tituloYNombreCompleto}}</h1>
        <h3>Consulta de información del usuario</h3>
      </div>
      <div class="d-flex">
        <div class="col-3 padding-div-low">
          <div class="area">
            <label v-on:click="abrirLaOpcionSeleccionada('informacionLaboral')" class="opcionSeleccionada">Información laboral</label>
            <label v-if="usuario.Persona != undefined && usuario.Persona != null" v-on:click="abrirLaOpcionSeleccionada('informacionPersonal')" class="opcionSeleccionada">Información personal</label>
            <label v-if="usuario.Abogado != undefined && usuario.Abogado != null" v-on:click="abrirLaOpcionSeleccionada('informacionProfesional')" class="opcionSeleccionada">Información profesional</label>
            <label v-on:click="abrirLaOpcionSeleccionada('cambiarContrasena')" class="opcionSeleccionada">Cambiar contraseña</label>
          </div>
        </div>
        <div class="col-9 padding-div-low">
          <component v-bind:is="componente" :props="usuario"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'

  import informacionLaboral from '@/components/Tablero/Usuario/informacionLaboral.vue'
  import informacionPersonal from '@/components/Tablero/Usuario/InformacionPersonal.vue'
  import informacionProfesional from '@/components/Tablero/Usuario/InformacionProfesional.vue'
  import cambiarContrasena from '@/components/Tablero/Usuario/CambioDeContrasena.vue'

  export default {
    components: {
      informacionLaboral,
      informacionPersonal,
      informacionProfesional,
      cambiarContrasena
    },
    data() {
      return {
        enumeraciones,
        usuario: {},
        componente: ""
      }
    },
    computed: {
      tituloYNombreCompleto() {
        let nombreCompleto = ""
        if (this.usuario.Nombre != undefined || this.usuario.Nombre != null) {
          nombreCompleto = (this.usuario.TipoTitulo != null && this.usuario.TipoTitulo != undefined ? this.usuario.TipoTitulo.Nombre + " " : "") +
            this.usuario.Nombre +
            (this.usuario.ApellidoPaterno != null && this.usuario.ApellidoPaterno != "" ? " " + this.usuario.ApellidoPaterno : "") +
            (this.usuario.ApellidoMaterno != null && this.usuario.ApellidoMaterno != "" ? " " + this.usuario.ApellidoMaterno : "");
        }
        return nombreCompleto;
      }
    },
    mounted() {
      this.obtenLaInformacionDelUsuario();
    },
    methods: {
      obtenLaInformacionDelUsuario: function () {
        comun.SeEstaCargandoInformacion(true);
        
        const parametros = {
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Cuentas.funcion.ObtenUsuario,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              this.usuario = {};
            } else {
              this.usuario = respuesta.data.Usuario;
              this.abrirLaOpcionSeleccionada("informacionLaboral");
            }

            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
          })
      },
      abrirLaOpcionSeleccionada: function (componente) {
        this.componente = componente;
      }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  label {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    font-size: medium;
    transition: all .3s;
  }

    label:hover {
      background-color: #444444;
      cursor: pointer;
    }

  opcionSeleccionada {
    background-color: #444444 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tablero/Usuario/Usuario.vue